import { renderMagazineSwiper } from 'js/magazin/initMagazineSwiper'

export const renderSliderArticlesMagazine = (slider) => renderMagazineSwiper(slider, {
  containerSelector: '.slider-articles-magazine-container',
  theme: 'white',
  mobileMax: 1,
  desktopMax: 2,
  overrides: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
  },
})
